export const TOGGLE_FILTERS = ['description'];

export const OTHER_TEAMS_KEY = 'Others';
